import { render } from "./QrCode.vue?vue&type=template&id=17636e3e"
import script from "./QrCode.vue?vue&type=script&lang=js"
export * from "./QrCode.vue?vue&type=script&lang=js"
script.render = render

export default script